// extracted by mini-css-extract-plugin
module.exports = {"footer-container":"PEISectionFooter_footer-container__6B9Vo","keep-together":"PEISectionFooter_keep-together__WQs1m","link":"PEISectionFooter_link__TPNOA"};